import "./App.css";
import React, { useState, useEffect } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Sidebar from "./Components/Admin/Sidebar";
import Dashboard from "./Components/Admin/pages/Dashboard";
import Login from "./Components/Admin/Login";
import Category from "./Components/Admin/pages/Category";
import Editors from "./Components/Admin/pages/Editors";
import ClientDetails from "./Components/Admin/pages/Client-Details";
import Invoice from "./Components/Admin/pages/Invoice";
import TaskManagement from "./Components/Admin/pages/Task Management/Task-Management";
import Register from "./Components/Admin/Register";
import Logout from "./Components/Admin/pages/Logout";
import Reports from "./Components/Admin/pages/Reports";
import Invoiceadd from "./Components/Admin/pages/Invoice-add";
import Bill from "./Components/Admin/pages/Bill";
import InvoiceUpdate from "./Components/Admin/pages/InvoiceUpdate";
import ReportPrint from "./Components/Admin/pages/ReportPrint";
import Projectreport from "./Components/Admin/pages/Project-report";
import InvoicePrint from "./Components/Admin/pages/InvoicePrint";
import axios from "axios";
import apiUrl from "./Components/Environment/Api";
import Passwordchange from "./Components/Admin/pages/Password-change";
import PageNotFound from "./Components/Admin/PageNotFound";
import Add_TaskManagement from "./Components/Admin/pages/Task Management/Add_Taskmanagement";
import Update_Taskmanagement from "./Components/Admin/pages/Task Management/Update_Taskmanagement";
import ClientRate from "./Components/Admin/pages/ClientRate";

const App = () => {
  const [auth, setAuth] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      axios
        .get(apiUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          console.log("Authentication response:", res.data);
          if (res.data.status === "success") {
            setAuth(true);
          } else {
            alert(res.data.message);
            setAuth(false);
          }
        })
        .catch((error) => {
          console.error("Authentication failed:", error);
          setAuth(false);
        });
    } else {
      setAuth(false);
    }
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            auth ? <Navigate to="/dashboard" /> : <Login setAuth={setAuth} />
          }
        />
        <Route
          path="/dashboard"
          element={
            auth ? (
              <Sidebar>
                <Dashboard />
              </Sidebar>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/category"
          element={
            auth ? (
              <Sidebar>
                <Category />
              </Sidebar>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/client-rate"
          element={
            auth ? (
              <Sidebar>
                <ClientRate />
              </Sidebar>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/editors"
          element={
            auth ? (
              <Sidebar>
                <Editors />
              </Sidebar>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/client-details"
          element={
            auth ? (
              <Sidebar>
                <ClientDetails />
              </Sidebar>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/invoice"
          element={
            auth ? (
              <Sidebar>
                <Invoice />
              </Sidebar>
            ) : (
              <Navigate to="/" />
            )
          }
        />

        {/* task management */}
        <Route
          path="/task-management"
          element={
            auth ? (
              <Sidebar>
                <TaskManagement />
              </Sidebar>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/add-taskmanagement"
          element={
            auth ? (
              <Sidebar>
                <Add_TaskManagement />
              </Sidebar>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/update-taskmanagement/:id"
          element={
            auth ? (
              <Sidebar>
                <Update_Taskmanagement />
              </Sidebar>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/reports"
          element={
            auth ? (
              <Sidebar>
                <Reports />
              </Sidebar>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/register"
          element={
            auth ? (
              <Sidebar>
                <Register />
              </Sidebar>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/logout"
          element={
            auth ? (
              <Sidebar>
                <Logout />
              </Sidebar>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/invoiceadd"
          element={
            auth ? (
              <Sidebar>
                <Invoiceadd />
              </Sidebar>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/reportprint"
          element={
            auth ? (
              <Sidebar>
                <ReportPrint />
              </Sidebar>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/projectreport"
          element={
            auth ? (
              <Sidebar>
                <Projectreport />
              </Sidebar>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/invoice/bill/:invoice_id"
          element={
            auth ? (
              <Sidebar>
                <Bill />
              </Sidebar>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/invoice/invoiceprint/:invoice_id"
          element={
            auth ? (
              <Sidebar>
                <InvoicePrint />
              </Sidebar>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/invoice/invoiceupdate/:invoice_id"
          element={
            auth ? (
              <Sidebar>
                <InvoiceUpdate />
              </Sidebar>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/passwordchange"
          element={
            auth ? (
              <Sidebar>
                <Passwordchange />
              </Sidebar>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
